<template>
  <div id="data-list-list-view">
    <vs-table
      ref="holeTable"
      search
      :data="holes"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <vs-row vs-type="flex" vs-justify="space-between">
          <vs-col vs-type="flex" vs-justify="right" vs-align="center" vs-w="12">
            <feather-icon icon="PlusCircleIcon" class="cursor-pointer mr-5" svg-classes="h-6 w-6" @click="addNewHole" />
          </vs-col>
        </vs-row>
      </div>
      <template slot="thead">
        <vs-th>{{$t('Action')}}</vs-th>
        <vs-th sort-key="code">{{$t('Drilling.Holes.Code')}}</vs-th>
        <vs-th sort-key="drillHoleType">{{$t('Drilling.DrillHoleTypes.Name')}}</vs-th>
        <vs-th sort-key="coordinateSystemType">{{$t('Drilling.CoordinateSystemTypes.Name')}}</vs-th>
        <vs-th sort-key="targetZoneId">{{$t('Drilling.Zones.SingleTitle')}}</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td width="150px" class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="openDeleteConfirm(tr.holeId, tr.code)"
              />
            </vs-td>
            <vs-td >
              <p class="font-medium truncate">{{ tr.code }}</p>
            </vs-td>
            <vs-td >
              <p class="font-medium truncate">{{ getDrillHoleTypeName(tr.drillHoleType) }}</p>
            </vs-td>
            <vs-td >
              <p class="font-medium truncate">{{ getCoordinateName(tr.coordinateSystemType) }}</p>
            </vs-td>
            <vs-td >
              <p class="font-medium truncate">{{ getZoneName(tr.targetZoneId) }}</p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>
<script>

import CoordinateSystemTypeEnum from "./../../CoordinateSystemTypeEnum.js";

export default {
  props: {
    holes: {
      type: Array,
      default: () => {}
    },
    zones : {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
    }
  },
  mounted() {

  },
  methods: {
    getCoordinateName(coordinateSystemType) {
      if (coordinateSystemType !== undefined && coordinateSystemType !== CoordinateSystemTypeEnum.Unknown && coordinateSystemType !== null) {
        return this.$t("Drilling.CoordinateSystemTypes." + coordinateSystemType);
      } else {
        return "";
      }
    },

    getDrillHoleTypeName(drillHoleType) {
      if (drillHoleType !== undefined && drillHoleType !== null) {
        return this.$t("Drilling.DrillHoleTypes." + drillHoleType);
      } else {
        return "";
      }
    },  

    getZoneName(targetZoneId) {
      const zone = this.zones.find(z => z.zoneId === targetZoneId);
      if (zone) {
        return zone.name;
      }
      else {
        return "";
      }
    },
    addNewHole() {
      this.$emit("onAddHole");
    },
    editData(data) {
      this.$emit("onEditHole", data);
    },

    openDeleteConfirm(holeId, holeCode) {
      this.$deleteConfirmation({
        text: this.$t('Drilling.Holes.ConfirmDelete'),
        accept: () => this.deleteRecord(holeId, holeCode)
      });

    },
    deleteRecord (holeId, holeCode) {
      this.$emit("onDeleteHole", holeId, holeCode);
    }
  }
};
</script>
<style lang="scss">
#data-list-list-view {
.vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 0.8rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 8px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--tbody-table {
      min-width: 200px;
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

